


















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import Draggable from 'vuedraggable'

import {
  CreateOptionGroupModal,
  InfiniteScroll,
  NetworkErrorEmptyState,
  OptionGroupTile,
  VsLoading
} from '@/components'

import { EmptyState, MobileLayout } from '@/layouts/components'

import {
  ActionButton,
  AsyncState,
  DropDownButton,
  ModalState,
  OptionGroup,
  OptionGroupsResourcePayload
} from '@/models'

import { ItemGroupOptionGroups } from '@/store/menu/state'
import { RelationMap } from '@/store/models'
import { RootState } from '@/store/state'
import { isFood } from '@/utils'

@Component({
  components: {
    CreateOptionGroupModal,
    Draggable,
    EmptyState,
    InfiniteScroll,
    MobileLayout,
    NetworkErrorEmptyState,
    OptionGroupTile,
    VsLoading
  }
})
export default class OptionGroups extends Vue {
  @Prop({ type: Number, required: true })
  readonly itemGroupId!: number

  loadState = new AsyncState()
  updateOptionGroupState = new AsyncState()
  createState = new ModalState()

  data: OptionGroupsResourcePayload[] = []

  draggableOptionGroups: OptionGroup[] = []

  enabled = false
  drag = false

  get buttons (): (ActionButton | DropDownButton)[] {
    return this.enabled
      ? [
        {
          text: 'Cancelar',
          handler: () => {
            this.optionGroups.forEach((e, i) => { this.draggableOptionGroups[i] = e })
            this.enabled = false
          },
          isDisabled: !this.hasChanges
        },
        {
          text: 'Salvar',
          handler: this.handleSubmit,
          isDisabled: !this.hasChanges || this.updateOptionGroupState.isPending
        }
      ]
      : [
        {
          icon: 'more_vert',
          color: 'dark',
          items: [
            {
              text: 'Reordenar',
              handler: () => { this.enabled = true }
            }
          ]
        }
      ]
  }

  get itemGroupOptionGroups (): ItemGroupOptionGroups | undefined {
    return this.itemGroupsOptionGroups[this.itemGroupId]
  }

  get optionGroups () {
    return this.orderedOptionGroups(this.itemGroupId)
  }

  get showFab () {
    return this.total > 0 || this.loadState.isResolved
  }

  get total () {
    return this.itemGroupOptionGroups
      ? this.itemGroupOptionGroups.total
      : 0
  }

  get hasChanges () {
    return this.enabled === true && this.data !== []
  }

  get emptyStateText () {
    return isFood() ? 'Cardápio' : 'Catálogo'
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  @State((state: RootState) => state.menu.itemGroups.optionGroups)
  readonly itemGroupsOptionGroups!: RelationMap<ItemGroupOptionGroups>

  @Getter('menu/orderedOptionGroups')
  readonly orderedOptionGroups!: (itemGroupId: number) => OptionGroup[]

  @Action('menu/loadOptionGroupPage')
  loadOptionGroupPage!: (itemGroupId: number) => Promise<void>

  @Action('menu/updateSequences')
  updateSequences!: (data: { itemGroupId: number; payload: OptionGroupsResourcePayload[]}) => Promise<void>

  @Watch('optionGroups', { immediate: true })
  onOptionGroupChange () {
    this.optionGroups.forEach((e, i) => { this.draggableOptionGroups[i] = e })
  }

  @Watch('draggableOptionGroups')
  onDataChange () {
    let index = 1
    this.data = []
    for (const optionGroup of this.draggableOptionGroups) {
      this.data.push({
        id: optionGroup.id,
        sequence: index
      })
      index++
    }
  }

  created () {
    if (this.total === 0) {
      this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadOptionGroupPage(this.itemGroupId)
    )

    return this.optionGroups.length > 0
  }

  async handleSubmit () {
    if (!this.hasChanges) {
      return
    }

    try {
      await this.updateOptionGroupState.handle(
        this.updateSequences({
          itemGroupId: this.itemGroupId,
          payload: this.data
        })
      )

      this.$vs.notify({
        title: 'Ordem alterada com sucesso.',
        color: 'success',
        fullWidth: true
      })

      this.enabled = false
    } catch (e) {
      this.$vs.notify({
        title: 'Não foi possível alterar.',
        color: 'danger',
        fullWidth: true
      })

      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
